<div class="content-container min-height m-t-20" *ngIf="organizationNotFound">
  <div class="spacer">
  </div>
  <wsd-not-found-page></wsd-not-found-page>
</div>

<div class="content-container min-height m-t-20" *ngIf="organization">
  <div class="spacer">
    <a class="detail-back-button" (click)="goBack()">
      {{ 'WS_DIRECTORY.ORG_MODIFY.BACK_BUTTON' | translate }}
    </a>
  </div>
  <div class="ui-g">

    <div class="ui-g-12">
      <div class="main-topic-panel wsd-item-detail">
        <h3 class="show-on-mobile m-t-10"
            *gsShowIfHasPermission="['PUBLIC', 'ORGANIZATION_NAME_READ']">
          {{ organization.name }}
        </h3>
        <div class="ui-g">
          <div class="ui-g-8">
            <h3 class="show-on-desktop"
                *gsShowIfHasPermission="['PUBLIC','ORGANIZATION_NAME_READ']">
              {{ organization.name }}
            </h3>
            <p class="organization-name-founding-date"
               *gsShowIfHasPermission="['PUBLIC','ORGANIZATION_SUBTYPE_READ']">
              <span>{{ organization?.organizationSubtype?.name }}</span>
              <span *ngIf="organization.foundingDate">since {{ organization.foundingDate | date: 'mediumDate' }}</span>
            </p>
            <p class="m-b-30" *gsShowIfHasPermission="['PUBLIC','PARENT_ORGANIZATION_READ']">
              <a *ngIf="organization.parentOrganization"
                 [routerLink]="['/organizations', organization.parentOrganization?.id, 'detail']">
                {{ organization?.parentOrganization?.name }}
              </a>
              <span *ngIf="organization.parentOrganization"> &#9679; </span>
              <span>{{ organization.country.name}}</span>
              <span *ngIf="organization.country"> &#9679; </span>
              <span *ngIf="organization.region">{{ organization.region.name}}</span>
            </p>
            <wsd-organization-address
              [addresses]="organization.addresses"
              [allowedTypes]="['BUSINESS']">
            </wsd-organization-address>
          </div>
          <div class="ui-g-4" *gsShowIfHasPermission="['PUBLIC','ORGANIZATION_LOGO_READ']">
            <div class="image-holder">
              <img src="../../../assets/images/no_image.png" *ngIf="!imageSrc" class="story-image-placeholder">
              <img [src]="imageSrc" *ngIf="imageSrc">
            </div>
            <button *ngIf="editable" pButton
                    label="{{ 'WS_DIRECTORY.ORG_DETAIL.MODIFY_BUTTON' | translate}}"
                    [routerLink]="['/organizations', organization.id, 'modify']"
                    class="w-100 m-b-30">
            </button>

            <div *gsShowIfHasPermission="['DELETE_ORGANIZATION_READ']">
              <button *ngIf="deleteable" pButton type="button"
                      (click)="delete()"
                      label="{{ 'WS_DIRECTORY.ORG_DETAIL.DELETE_BUTTON' | translate}}"
                      class="w-100 m-b-30 ui-button-danger">
              </button>
            </div>
          </div>
        </div>


        <div *gsShowIfHasPermission="['PUBLIC','CONTACTS_ORGANIZATION_READ']">
          <h4>{{ 'WS_DIRECTORY.ORG_DETAIL.CONTACT' | translate }}</h4>
          <div class="ui-g">
            <div class="ui-g-6 div-m-b-10" *ngIf="organization.contacts?.length">
              <ng-container *ngFor="let contact of organization.contacts">
                <div *ngIf="showContact(contact)">
                  <label class="inline">
                    {{ 'CONTACT_TYPES.' + contact.type | translate }}
                  </label>
                  <span
                    *ngIf="isAuthenticated && contact.type === 'EMAIL'; else replaceAtSignCondition">
                    {{ contact.value }}
                  </span>
                  <ng-template #replaceAtSignCondition>
                    {{ contact.value | replaceAtSign }}
                  </ng-template>
                </div>
              </ng-container>
            </div>

            <div class="ui-g-6 div-m-b-10">
              <wsd-organization-address
                [addresses]="organization.addresses"
                [allowedTypes]="['MAILING']">
              </wsd-organization-address>
            </div>
          </div>
        </div>

        <div *ngIf="!organization.visibleContacts">
          {{ 'INFO_CONTACT.MESSAGE' | translate }}
        </div>

        <div *ngIf="organization.children?.length > 0">
          <h4>{{ 'WS_DIRECTORY.ORG_DETAIL.CHILDREN_ORGANIZATION_LABEL' | translate }}</h4>
          <div *ngFor="let children of organization.children"
               class="ui-g">
            <div class="ui-g-6 ui-sm-12">
              <a [routerLink]="['/organizations', children.id, 'detail']">
                {{ children.name }}
              </a>
            </div>
          </div>
        </div>

        <div *gsShowIfHasPermission="['APPOINTEES_READ']">
          <div *ngIf="organization.appointees.length > 0">
            <h4>{{ 'WS_DIRECTORY.ORG_DETAIL.APPOINTEES' | translate }}</h4>
            <div *ngFor="let appointee of organization.appointees"
                 class="ui-g">
              <div class="ui-g-6 ui-sm-12" [ngClass]="(appointee?.official===true)?'official-contact':''">
                <span *ngIf="appointee.directoryTitle">{{appointee.directoryTitle }}</span>
                <span *ngIf="!appointee.directoryTitle">{{appointee.standardTitle.name }}</span>
              </div>
              <div class="ui-g-6 ui-sm-12">
                <a [routerLink]="['/persons', appointee.consultant.id, 'detail']">
                  {{ getFullName(appointee) }}
                </a>
              </div>
            </div>
          </div>
        </div>

        <div class="ui-g">
          <div class="ui-g-6 ui-sm-12" *gsShowIfHasPermission="['PUBLIC','UPCOMING_EVENTS_READ']">
            <h4>{{ 'WS_DIRECTORY.ORG_DETAIL.UPCOMING_EVENTS' | translate }}</h4>
            <div *ngFor="let upcomingEvent of upcomingEvents" class="upcomingEvents">
              <div class="upcomingEventTitle">{{upcomingEvent.title}}</div>
              <div><span>{{upcomingEvent.start_date | date: 'mediumDate'}}</span> -
                <span>{{upcomingEvent.end_date | date: 'mediumDate' }}</span>
              </div>
              <div>{{upcomingEvent.location}}</div>
            </div>
          </div>
          <div class="ui-g-6 ui-sm-12" *gsShowIfHasPermission="['PUBLIC','HOSTED_PAST_WOSM_EVENTS_READ']">
            <h4>{{ 'WS_DIRECTORY.ORG_DETAIL.HOSTED_PAST_WOSM_EVENTS' | translate }}</h4>
            <div>{{ organization.pastWosmEvents || '' }}</div>
          </div>
        </div>

        <div *ngIf="organization?.organizationType?.name === 'National Scout Organizations'">
          <h4>{{ 'WS_DIRECTORY.ORG_DETAIL.MEMBERSHIP' | translate }}</h4>
          <div class="ui-g" *gsShowIfHasPermission="['PUBLIC','YEAR_OF_WOSM_MEMBERSHIP_READ']">
            <div class="ui-g-6">{{ 'WS_DIRECTORY.ORG_DETAIL.WOSM_MEMBERSHIP_YEAR' | translate }}</div>
            <div class="ui-g-6">{{ organization.wosmMembershipYear }}</div>
          </div>
          <div class="ui-g" *gsShowIfHasPermission="['PUBLIC','WOSM_MEMBERSHIP_HISTORY_READ']">
            <div class="ui-g-6">{{ 'WS_DIRECTORY.ORG_DETAIL.WOSM_MEMBERSHIP_HISTORY' | translate }}</div>
            <div class="ui-g-6">{{ organization.wosmMembership }}</div>
          </div>
          <div class="ui-g" *gsShowIfHasPermission="['PUBLIC','MEMBER_OF_WAGGGS_READ']">
            <div class="ui-g-6">{{ 'WS_DIRECTORY.ORG_DETAIL.WAGGGS_MEMBER' | translate }}</div>
            <div class="ui-g-6">{{ getWagggsValue() }}</div>
          </div>
          <div class="ui-g" *gsShowIfHasPermission="['PUBLIC','FOUNDING_DATE_OF_ORGANIZATION_READ']">
            <div class="ui-g-6">{{ 'WS_DIRECTORY.ORG_DETAIL.FOUNDING_DATE_OF_ORGANIZATION' | translate }}</div>
            <div class="ui-g-6">{{ organization.foundingDate | date: 'MM/dd/yyyy'}}</div>
          </div>
        </div>

        <div >
          <h4>{{ 'WS_DIRECTORY.ORG_DETAIL.MEMBERSHIP_FEE_CATEGORY' | translate }}</h4>
          <div class="ui-g" *gsShowIfHasPermission="['ORGANIZATION_FEE_CATEGORY_READ']">
            <div class="ui-g-6">{{ 'WS_DIRECTORY.ORG_DETAIL.FEE_CATEGORY' | translate }}</div>
            <div class="ui-g-6">{{ organization.feeCategory }}</div>
          </div>
          <div class="ui-g" *gsShowIfHasPermission="['ORGANIZATION_EVENT_CATEGORY_READ']">
            <div class="ui-g-6">{{ 'WS_DIRECTORY.ORG_DETAIL.EVENT_CATEGORY' | translate }}</div>
            <div class="ui-g-6">{{ organization.eventCategory }}</div>
          </div>
        </div>

        <div *ngIf="organization?.organizationType?.name === 'National Scout Organizations'">
          <h4 *ngIf="isAuthenticated">{{ 'WS_DIRECTORY.ORG_DETAIL.ORGANIZATION_DETAILS' | translate }}</h4>
          <div class="ui-g" *gsShowIfHasPermission="['ORGANIZATION_NAME_FR_READ']">
            <div class="ui-g-6">{{ 'WS_DIRECTORY.ORG_DETAIL.ORGANIZATION_NAME_FR' | translate }}</div>
            <div class="ui-g-6">{{ organization.nameFr }}</div>
          </div>
          <div class="ui-g" *gsShowIfHasPermission="['SECONDARY_NAME_READ']">
            <div class="ui-g-6">{{ 'WS_DIRECTORY.ORG_DETAIL.ORGANIZATION_SECONDARY_NAME' | translate }}</div>
            <div class="ui-g-6">{{ organization.secondaryName }}</div>
          </div>
          <div class="ui-g" *gsShowIfHasPermission="['SECONDARY_NAME_FR_READ']">
            <div class="ui-g-6">{{ 'WS_DIRECTORY.ORG_DETAIL.ORGANIZATION_SECONDARY_NAME_FR' | translate }}</div>
            <div class="ui-g-6">{{ organization.secondaryNameFr }}</div>
          </div>
          <div class="ui-g" *gsShowIfHasPermission="['ORGANIZATION_ACRONYM_READ']">
            <div class="ui-g-6">{{ 'WS_DIRECTORY.ORG_DETAIL.ORGANIZATION_ACRONYM' | translate }}</div>
            <div class="ui-g-6">{{ organization.acronym }}</div>
          </div>
          <div class="ui-g" *gsShowIfHasPermission="['ABBREVIATION_UNIQUE_ACRONYM_READ']">
            <div class="ui-g-6">{{ 'WS_DIRECTORY.ORG_DETAIL.ABBREVIATION_UNIQUE_ACRONYM' | translate }}</div>
            <div class="ui-g-6">{{ organization.fullAcronym }}</div>
          </div>
          <div class="ui-g" *gsShowIfHasPermission="['SUSPENSION_STATUS_READ']">
            <div class="ui-g-6">{{ 'WS_DIRECTORY.ORG_DETAIL.SUSPENSION_STATUS' | translate }}</div>
            <div class="ui-g-6">
              {{ 'SUSPENSION_STATUS.' + (organization.suspensionStatus || 'NOT_SUSPENDED') | translate }}
            </div>
          </div>
          <div class="ui-g" *gsShowIfHasPermission="['ORGANIZATION_ORDER_READ']">
            <div class="ui-g-6">{{ 'WS_DIRECTORY.ORG_DETAIL.ORGANIZATION_ORDER' | translate }}</div>
            <div class="ui-g-6">{{ organization.order }}</div>
          </div>
          <div class="ui-g" *gsShowIfHasPermission="['ORGANIZATION_PREFERRED_GLOBAL_LANGUAGE_READ']">
            <div class="ui-g-6">{{ 'WS_DIRECTORY.ORG_DETAIL.ORGANIZATION_PREFERRED_GLOBAL_LANGUAGE' | translate }}</div>
            <div class="ui-g-6">{{ organization?.globalLanguage?.name }}</div>
          </div>
          <div class="ui-g" *gsShowIfHasPermission="['ORGANIZATION_PREFERRED_WORKING_LANGUAGE_READ']">
            <div class="ui-g-6">{{ 'WS_DIRECTORY.ORG_DETAIL.ORGANIZATION_PREFERRED_WORKING_LANGUAGE' | translate }}
            </div>
            <div class="ui-g-6">{{ organization?.workingLanguage?.name }}</div>
          </div>
          <div class="ui-g" *gsShowIfHasPermission="['ORGANIZATION_CURRENCY_READ']">
            <div class="ui-g-6">{{ 'WS_DIRECTORY.ORG_DETAIL.ORGANIZATION_CURRENCY' | translate }}</div>
            <div class="ui-g-6">{{ organization?.currency?.name }}</div>
          </div>
          <div class="ui-g" *gsShowIfHasPermission="['NOTES_READ']">
            <div class="ui-g-6">{{ 'WS_DIRECTORY.ORG_DETAIL.NOTES' | translate }}</div>
            <div class="ui-g-6">{{ organization.notes }}</div>
          </div>
          <div class="ui-g" *gsShowIfHasPermission="['KEY_SUMMARY_OF_NSO_READ']">
            <div class="ui-g-6">{{ 'WS_DIRECTORY.ORG_DETAIL.KEY_SUMMARY_OF_NSO_PROVIDED_BY_REGION' | translate }}</div>
            <div class="ui-g-6" *ngFor="let summaryListItem of organization.summaryList">{{ summaryListItem.description
              }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<p-confirmDialog appendTo="body" icon="fa fa-question-circle" [style]="{width: '425px'}"></p-confirmDialog>
